<span [innerHTML]="currentText" aria-live="polite" aria-atomic="true"></span>
@if (showMoreLess) {
	<ea-button-link
		name="readMoreOrLess"
		(onClick)="toggleView()"
		title="readMoreOrLess"
	>
		{{ isCollapsed ? moreText : lessText }}
	</ea-button-link>
}
